import React from 'react'
import ClientCategories from '../../client/ClientCategories'
import V3ProfileRouteShell from '../profile/V3ProfileRouteShell'

export default function V3ClientCategoriesPage() {
  return (
    <V3ProfileRouteShell>
      <ClientCategories visualVariant="v3" />
    </V3ProfileRouteShell>
  )
}

